import { isInFlutterApp } from ".";

export const fontPxLevels = [14, 16, 18, 20, 22]

/** 是否跟随系统文字大小 */
export const getIsUseSystemFontSize = (): boolean => {
  return localStorage.getItem("is_custom_global_font_size") !== "1"
}

export const setIsUseSystemFontSize = (value: boolean) => {
  if (value) {
    localStorage.removeItem("is_custom_global_font_size")
    return
  }
  localStorage.setItem("is_custom_global_font_size", "1")
}

export const changeGlobalFontLevel = (value: number) => {
  const levels = [-2, 0, 2, 4, 6]
  const getLevelPx = (v: number) => v + levels[value]
  const docElStyle = document.documentElement.style
  docElStyle.fontSize = getLevelPx(16) + "px"
  docElStyle.setProperty("--giant-font-size", getLevelPx(24) + "px")
  docElStyle.setProperty("--huge-font-size", getLevelPx(20) + "px")
  docElStyle.setProperty("--greater-font-size", getLevelPx(18) + "px")
  docElStyle.setProperty("--heavy-font-size", getLevelPx(16) + "px")
  docElStyle.setProperty("--big-font-size", getLevelPx(15) + "px")
  docElStyle.setProperty("--little-font-size", getLevelPx(14) + "px")
  docElStyle.setProperty("--little-font-size13", getLevelPx(13) + "px")
  docElStyle.setProperty("--mini-font-size", getLevelPx(12) + "px")
  docElStyle.setProperty("--mini-font-size11", getLevelPx(11) + "px")
  docElStyle.setProperty("--adm-font-size-1", getLevelPx(9) + "px")
  docElStyle.setProperty("--adm-font-size-2", getLevelPx(10) + "px")
  docElStyle.setProperty("--adm-font-size-3", getLevelPx(11) + "px")
  docElStyle.setProperty("--adm-font-size-4", getLevelPx(12) + "px")
  docElStyle.setProperty("--adm-font-size-5", getLevelPx(13) + "px")
  docElStyle.setProperty("--adm-font-size-6", getLevelPx(14) + "px")
  docElStyle.setProperty("--adm-font-size-7", getLevelPx(15) + "px")
  docElStyle.setProperty("--adm-font-size-8", getLevelPx(16) + "px")
  docElStyle.setProperty("--adm-font-size-9", getLevelPx(17) + "px")
  docElStyle.setProperty("--adm-font-size-10", getLevelPx(18) + "px")
  localStorage.setItem('global_font_level', String(value))
}

/**
 * @param rate 文字倍率, 如 0.8, 1, 1.2, 1.88 等
 * @returns level 0, 1, 2, 3, 4 5 个等级5种文字大小
 */
export const transformRateToLevel = (rate: number): number => {
    const rates = [0.875, 1, 1.125, 1.25, 1.375]
    for (let i = rates.length - 1; i > 0; i--) {
      if (rate >= rates[i] - 0.0625) {
        return i
      }
    }
    return 0
}

export const getSystemFontLevel = () => {
  try {
    const browserFontSizeStr = getComputedStyle(document.documentElement).fontSize || "16"
    const browserFontSize = parseInt(browserFontSizeStr) 
    for (let i = 0; i < fontPxLevels.length; i++) {
      if (browserFontSize <= fontPxLevels[i]) {
        return i
      }
    }
    return fontPxLevels.length - 1
  } catch {
    return 1
  }
}

export const initSystemFontSize = () => {
  if (getIsUseSystemFontSize()) {
    // 等待Flutter文字大小初始化延迟
    setTimeout(() => {
      changeGlobalFontLevel(getSystemFontLevel())
    }, 100)
  } else if (localStorage.getItem('global_font_level')) {
    changeGlobalFontLevel(Number(localStorage.getItem('global_font_level')))
  }
}
